module.exports = __webpack_public_path__ + "img/football.68390688.svg";